const NST_TO_STAT = { NST_ATK: "atk", NST_HP: "hp", NST_DEF: "def" };

// 스타링크 증폭(synchro_level_data.json)은 20레벨 구간마다 델타값을 가지고 있고,
// 실제 적용값은 해당 레벨 이하 모든 구간의 델타를 누적 합산한 값이다.
// (기존 레벨당 성장(stat_per_level)과는 별개로 더해지는 추가 스탯)
const getSynchroBonus = (synchroLevelData, level) => {
    const bonus = { atk: 0, hp: 0, def: 0 };
    if (!synchroLevelData) return bonus;

    synchroLevelData
        .filter((entry) => entry.level <= level)
        .forEach((entry) => {
            entry.stats.forEach((stat) => {
                const key = NST_TO_STAT[stat.type];
                if (key) bonus[key] += stat.value;
            });
        });

    return bonus;
};

export { getSynchroBonus };
